<template>
    <div class="title1">
        <P>报警事件</P>
        <div class="title-info">Patrol statistics</div>
    </div>
    <div class="box">
        <ul class="list">
            <li>
                <span>变色油色谱传感器</span>
                <span>采集数据</span>
                <span>2022/5/1</span>
            </li>
            <li>
                <span>变色油色谱传感器</span>
                <span>采集数据</span>
                <span>2022/5/1</span>
            </li>
            <li>
                <span>变色油色谱传感器</span>
                <span>采集数据</span>
                <span>2022/5/1</span>
            </li>
            <li>
                <span>变色油色谱传感器</span>
                <span>采集数据</span>
                <span>2022/5/1</span>
            </li>
            <li>
                <span>变色油色谱传感器</span>
                <span>采集数据</span>
                <span>2022/5/1</span>
            </li>
            <li>
                <span>变色油色谱传感器</span>
                <span>采集数据</span>
                <span>2022/5/1</span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "patrolS"
    }
</script>

<style scoped lang="less">
    @import "./../../assets/canshu";
    .box{
        width: 363px;
        height: 247vh*@vh;
        background: url("./../../assets/patrolS-bg.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 26vh*@vh;
        font-family: cn;
        color: #fff;
        box-sizing: border-box;
        padding-top: 8vh*@vh;
        .list{
            li{
                display: flex;
                justify-content: space-around;
                align-items: center;
                width: 360px;
                height: 25vh*@vh;
                margin-bottom: 16vh*@vh;
                &:hover{
                    background: url("./../../assets/perceived-list-active.png") no-repeat;
                    background-size: 100% 100%;
                }
                span{
                    font-size: 12px;
                }
            }
        }
    }
</style>